<template>
    <b-modal v-model="show"
             title="ТАДБИРКОРЛИК ФОЙДАСИНИ ПАРАМЕТРИ"
             :no-close-on-esc="true" :no-close-on-backdrop="true"
             size="lg"
    >
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label for="category">Категория <span class="red">*</span></label>
                        <select name="category" id="category"
                                class="form-control"
                                v-model="data.category"
                                :class="{invalid: $v.data.category.$error}"
                        >
                            <option value="Notorious">Нотурар</option>
                            <option value="Residential">Турар</option>
                        </select>
                    </div>
                    <div class="form-group">
                        <label>Қўрилиш даври(йилда) <span class="red">*</span></label>
                        <numeric-input :precision="2" v-model="data.period"
                                       :class="{invalid: $v.data.period.$error}">
                        </numeric-input>
                    </div>
                    <div class="form-group">
                        <label>Аванс улуши % да (Со)<span class="red">*</span></label>
                        <numeric-input :precision="2" v-model="data.valueCo" :class="{invalid: $v.data.valueCo.$error}" @change="calculateValue"></numeric-input>
                    </div>
                    <div class="form-group">
                        <label>Капитал қўйилманинг йиллик қайтиш нормаси % да(Уа)<span class="red">*</span></label>
                        <numeric-input :precision="2" v-model="data.valueUa" :class="{invalid: $v.data.valueUa.$error}" @change="calculateValue"></numeric-input>
                    </div>
                    <div class="form-group">
                        <label>Тадбиркорлик фойдасини (Ппр),%<span class="red">*</span></label>
                        <numeric-input :precision="6" v-model="data.value" :class="{invalid: $v.data.value.$error}"></numeric-input>
                    </div>
                    <div class="form-group">
                        <label>Индекс санаси <span class="red">*</span></label>
                        <date-picker class="form-control"
                                     v-model="data.date"
                                     format="dd/MM/yyyy"
                                     :class="{'is-invalid':$v.data.date.$error}"
                        ></date-picker>
                    </div>
                    <div class="form-group">
                        <div class="form-check pl-0">
                            <label class="form-check-label" style="padding-left:22px !important">
                                <input class="form-check-input" type="checkbox"
                                       v-model="data.active">
                                <span class="form-check-sign"></span>
                                Холати
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" v-if="hasPermission('SETTINGS_BUILDING_BUSINESS_COEFFICIENT_ADD')" @click="save">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="show=!show">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {clone} from '@/shared/utils';
    import { required,minValue } from 'vuelidate/lib/validators'
    import DatePicker from 'vuejs-datepicker';

    export default {
        name: "BusinessCoefficientEditModal",
        components: {
            'b-modal': bModal,
            DatePicker
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                data: this.initData()
            }
        },
        validations: {
            data: {
                period: {
                    required,
                    minValue: minValue(0.01)
                },
                value: {
                    required,
                    minValue: minValue(0.01)
                },
                valueCo: {
                    required,
                    minValue: minValue(0.01)
                },
                valueUa: {
                    required,
                    minValue: minValue(0.01)
                },
                category: {
                    required
                },
                date: {
                    required: required
                }
            }
        },
        methods: {
            initData() {
                return {
                    value: 0,
                    period: 0,
                    valueCo: 0,
                    valueUa: 0,
                    category: 'Notorious',
                    active: true,
                    date: null
                };
            },
            calculateValue() {
                let Co = 0;
                let Ua = 0;
                let period = 0;
                if (this.data.valueCo && this.data.valueCo > 0 && this.data.valueUa && this.data.valueUa > 0) {
                    Co = this.data.valueCo / 100;
                    Ua = this.data.valueUa / 100;
                    period = this.data.period;
                    this.data.value = (0.5 * Ua * period * (1 + ((period * Ua) / 3) + (Co * (1 + ((2 * period * period * Ua * Ua) / 3)))) + 1).toPrecision(4)
                }
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                const vm = this;
                this.processing = true;
                this.$http.post('/business-coefficient', this.data)
                    .then(res => {
                        vm.processing = false;
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$eventBus.$emit('businessCoefficientFieldChanged', response);
                        }
                    },err => {
                        vm.processing = false;
                        console.log(err);
                    })
            }
        },
        created() {
            this.$eventBus.$on('showBusinessCoefficientEditModal', (data) => {
                if (data) {
                    this.data = clone(data);
                } else {
                    this.data = this.initData();
                }
                this.show = true;
            });
        }
    }
</script>

<style scoped>

</style>